import { Mutation, JsonApiRequestError } from '@farfetched/core';
import { chain } from '@leprecoins/effector';
import { createEvent, EventCallable, sample } from 'effector';
import { notify } from '../effector-notifications';
import { ModalFormModel, createModalFormModel } from './create-modal-form-model';

export type ConfirmModalModel<TModalData, TParams, TResponse> = ModalFormModel<TModalData> & {
	mutation: Mutation<TParams, TResponse, JsonApiRequestError>;
};

export const declareModalData = <TModalData>() => createEvent<TModalData>();

export const createConfirmModalModel = <TModalData, TParams, TResponse>({
	mutation,
	mapModalData,
	successMessageKey,
}: {
	modalData: EventCallable<TModalData>;
	mutation: Mutation<TParams, TResponse, JsonApiRequestError>;
	mapModalData: (modalData: TModalData) => TParams;
	successMessageKey: string;
}): ConfirmModalModel<TModalData, TParams, TResponse> => {
	const model = createModalFormModel<TModalData>({ fields: {} });

	sample({
		clock: model.form.submitted,
		source: model.$modalData,
		filter: Boolean,
		fn: mapModalData,
		target: mutation.start,
	});

	chain(mutation.finished.success, model.switcher.disable);

	notify(mutation.finished.success, successMessageKey);

	chain(model.modalClosed, mutation.reset);

	return {
		...model,
		mutation,
	};
};
